<template>
    <el-radio-group v-model="radio" @change="change">
        <el-radio-button :label="item.name" v-for="item in list" :key="item.id">{{item.name}}</el-radio-button>
    </el-radio-group>
</template>

<script>
    export default {
        name: "dis-tabs",
        data() {
            return {
                radio: "",
                list: [
                    {name: '今日远程门诊', page: '/main/referral/dis/distance/receive'},
                    {name: '未来几天远程门诊', page: '/main/referral/dis/distance/week'},
                    {name: '历史记录', page: '/main/referral/dis/distance/history'}
                ],
            }
        },
        created() {
            const {meta} = this.$route;
            this.radio = meta.title;
        },
        methods: {
            change() {
                const route = this.list.find(r => r.name === this.radio);
                this.$router.push(route.page);
            }
        },
    }
</script>

<style scoped>

</style>
